import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Parameter, CreateParameterDto, UpdateParameterDto } from '../models/parameter.model';
import { ApiResponse } from '../interfaces/api-response.interface';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {
  private readonly apiUrl = '/api/company/parameters';

  constructor(private http: HttpClient) {}

  getParameters(): Observable<ApiResponse<Parameter[]>> {
    return this.http.get<ApiResponse<Parameter[]>>(this.apiUrl);
  }

  getParameter(id: number): Observable<ApiResponse<Parameter>> {
    return this.http.get<ApiResponse<Parameter>>(`${this.apiUrl}/${id}`);
  }

  createParameter(data: CreateParameterDto): Observable<ApiResponse<Parameter>> {
    return this.http.post<ApiResponse<Parameter>>(this.apiUrl, data);
  }

  updateParameter(id: number, data: UpdateParameterDto): Observable<ApiResponse<Parameter>> {
    return this.http.put<ApiResponse<Parameter>>(`${this.apiUrl}/${id}`, data);
  }

  deleteParameter(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
